// Engelse vertalingen — secundaire taal voor Todoes, sleutel-voor-sleutel gelijk aan nl.js.
// Nieuwe sleutels toevoegen in dezelfde stap als het component dat ze gebruikt.
const en = {
  // =============================================
  // Algemeen / UI
  // =============================================
  'app.loading': 'Loading page...',
  'error.occurred': 'An error has occurred',

  // =============================================
  // TaskModal (pre-existing keys, ontbraken sinds Taak 5.1)
  // =============================================
  'modal.close': 'Close',

  // =============================================
  // ErrorBoundary
  // =============================================
  'errorboundary.title': 'Oops! Something went wrong.',
  'errorboundary.description':
    'An unexpected error occurred in the application.',
  'errorboundary.reload': 'Reload application',

  // =============================================
  // Confirm Dialog (Taak 0.5)
  // =============================================
  'confirm.delete.title': 'Delete task?',
  'confirm.delete.body':
    'Are you sure you want to delete this task and all its subtasks? This cannot be undone.',
  'confirm.cancel': 'Cancel',
  'confirm.delete': 'Delete',

  // =============================================
  // Wall modal (Free-tier limits)
  // =============================================
  'wall.project_limit.title': 'More projects with Lite',
  'wall.project_limit.body':
    "You've reached the maximum number of active projects on Free. Work without limits with Lite.",
  'wall.gcal_locked.title': 'Calendar sync is a Lite feature',
  'wall.gcal_locked.body':
    'Connect your Google Calendar and see everything in one place — available with Lite.',
  'wall.dashboard_scroll.title': 'More history with Lite',
  'wall.dashboard_scroll.body':
    'Review your full progress — Free shows the last week only.',
  'wall.understood': 'Got it',
  'wall.registerInterest': 'Notify me when available',
  'wall.interestThankYou': "Thanks, we'll let you know!",

  // =============================================
  // Quick Bar / GoBar (Taak 0.3)
  // =============================================
  'quickbar.placeholder':
    'New task... #project @context ~duration +person >date',
  'gobar.placeholder': 'Search or navigate...',

  // =============================================
  // Focus Task (Taak 0.4)
  // =============================================
  'focus.start': 'Start Focus',
  'focus.stop': 'Stop Focus',
  'focus.pause': 'Pause',
  'focus.inProgress': 'In progress',
  'focus.complete': 'Complete task',

  // =============================================
  // Onboarding (script scene 2)
  // =============================================
  'onboarding.hint.dismiss': 'Got it',
  'onboarding.focusHint.body':
    "Start focus on the task you're starting now.",
  'onboarding.focusHint.dismiss': 'Close',
  'onboarding.nextActionPanel.body':
    "This is where the next step of tasks you've split up shows up.",
  'onboarding.nextActionPanel.dismiss': 'Close',
  'onboarding.triageHint.title': 'Some tasks are still missing details.',
  'onboarding.triageHint.body':
    'Click this block to fill them in the Inbox.',
  'onboarding.quickAddHint.body':
    'Tip: try typing something like "{example}". Press {shortcut} to focus here. The same syntax works in the quick-add bar and inline editing. See Help for more.',
  'onboarding.quickAddHint.dismiss': 'Close',

  'activationnotice.completedSingular':
    '{count} task completed since you started. Nice progress!',
  'activationnotice.completedPlural':
    '{count} tasks completed since you started. Nice progress!',
  'activationnotice.dismiss': 'Close',

  // =============================================
  // Shared UI components
  // =============================================
  'shared.addTask': 'Add task',

  // =============================================
  // Today Page (Epic 1)
  // =============================================
  'today.triage': 'Inbox',
  'today.triage.time': 'Default duration',
  'today.triage.context': 'Context',
  'today.triage.project': 'Project',
  'dayprogressdots.of': 'of',

  // =============================================
  // Plan Page (Epic 2)
  // =============================================
  'plan.title': 'Planning',
  'plan.day': 'Day',
  'plan.week': 'Week',
  'plan.month': 'Month',
  'weekdaycell.morning': 'Morning',
  'weekdaycell.afternoon': 'Afternoon',
  'weekdaycell.evening': 'Evening',

  // =============================================
  // Organize Page (Epic 3)
  // =============================================
  'organize.title': 'Organize', // tests/auth.spec.js /Organize/i
  'organize.tabActive': 'Active',
  'organize.tabBacklog': 'Backlog',
  'organize.tabInbox': 'Inbox',
  'organize.selectTask': 'Select a task to see details',
  'organize.noTasks': 'No tasks match the current filters.',
  'organize.emptyBacklog': 'Nothing in Backlog.',
  'organize.emptyActive': 'No active tasks.',
  'organize.noSubtasks': 'Drag a task here',
  'organize.editTask': 'Edit task',
  'organize.confirmMoveWithDescendants':
    'This task has {count} subtasks. Are you sure you want to move it?',
  'inboxview.duration': 'Default duration',
  'inboxview.missingProject': 'No project',
  'inboxview.missingContext': 'No context',
  'inboxview.newContextPlaceholder': 'New context, e.g. @thuis',
  'inboxview.newProjectPlaceholder': 'New project, e.g. #work',
  'inboxview.selectGroup': 'Select a triage group to show drop zones',
  'inboxdropzone.dropHint': 'Drop a task here',
  'inboxdropzone.zoneAriaLabel': '{label} drop zone',
  'inboxdropzone.assignedAnnouncement': 'Task assigned to {label}',
  'inboxdropzones.toolbarLabel': 'Assign selected task to a drop zone',
  'inboxpage.empty': 'No tasks waiting for triage.',

  // =============================================
  // Dashboard Page (Epic 4)
  // =============================================
  'dashboard.title': 'Dashboard',
  'dashboard.completed': 'Completed',
  'dashboard.waiting': 'Waiting',
  'dashboard.noCompleted':
    'No completed tasks found matching the current filters.',
  'dashboard.noWaiting':
    'No delegated tasks found matching the current filters.',
  'dashboard.totalHours': 'completed this week',
  'dashboard.totalTasks': 'tasks completed',
  'dashboard.delta': 'vs. last week',
  'dashboard.activeDays': 'active days',
  'dashboard.bestDay': 'best day',
  'dashboard.biggestTask': 'biggest task — {meta}',
  'dashboard.biggestTaskShort': 'biggest task',
  'dashboard.projectBreakdownBars': 'Project bars',
  'dashboard.previousWeek': 'Previous week',
  'dashboard.nextWeek': 'Next week',
  'dashboard.weeklyChart': 'Hours per day',
  'dashboard.weeklyChartLegend': 'Projects this week',
  'dashboard.weeklyChartBars': 'Day bars',
  'dashboard.projectTimeThisWeek': 'Time per project — this week',

  // Relative date labels (planning / dashboard)
  'dates.yesterday': 'Yesterday',
  'dates.dayAfterTomorrow': 'Day after tomorrow',

  // =============================================
  // TaskItemBase (render helpers)
  // =============================================
  'taskitem.mainTask': 'Main task',
  'taskitem.deleteTask': 'Delete task',
  'taskitem.listPosition': '{title}, task {current} of {total}',
  'taskitem.overdueByDays': '{days}d overdue',
  // Waarde bewust identiek aan de Engelse fallback: tests/*.spec.js selecteert
  // dit element op de letterlijke tekst aria-label="Add subtask" (o.a. dnd.spec.js,
  // subtask-flow.spec.js, cascade-*.spec.js) — wijzig niet zonder die specs aan te passen.
  'taskitem.addSubtask': 'Add subtask',

  // =============================================
  // Task context menu (right-click)
  // =============================================
  'contextMenu.assign': 'Waiting for…',
  'contextMenu.delete': 'Delete',
  'contextMenu.addSubtask': 'Add subtask',
  'contextMenu.moveToTomorrow': 'Move to tomorrow',
  'contextMenu.moveToToday': 'Move to today',
  'contextMenu.moveToBacklog': 'Move to backlog',
  'contextMenu.moveToActive': 'Move to active',
  'contextMenu.clearAssignee': 'No longer waiting',

  // =============================================
  // Login / Logout / ProtectedRoute
  // =============================================
  'login.title': 'Welcome to Riposo', // tests/auth.spec.js contains 'Welcome to Riposo'
  'login.googleSignIn': 'Sign in with Google',
  'login.googleSignUp': 'Sign up with Google',
  'login.testUser': 'Test User Sign In (Test Only)',
  'login.or': 'or',
  'login.tabsLabel': 'Email sign-in options',
  'login.tabSignIn': 'Sign in',
  'login.tabSignUp': 'Sign up',
  'login.emailLabel': 'Email address',
  'login.passwordLabel': 'Password',
  'login.passwordConfirmLabel': 'Confirm password',
  'login.showPassword': 'Show password',
  'login.hidePassword': 'Hide password',
  'login.submitting': 'Please wait…',
  'login.forgotPassword': 'Forgot password?',
  'login.resetSend': 'Send reset link',
  'login.resetBackToSignIn': 'Back to sign in',
  'login.resetSuccess': 'If this address exists, we will send a link.',
  'login.resetCooldown': 'Send again in {seconds}s',
  'login.passwordStrength.weak': 'Weak',
  'login.passwordStrength.fair': 'Fair',
  'login.passwordStrength.strong': 'Strong',
  'auth.error.emailAlreadyInUse': 'This email is already registered.',
  'auth.error.emailLinkedToGoogle': 'This address is already linked to Google. Sign in with Google.',
  'auth.error.emailHasPasswordAccount': 'This address already has an account. Sign in.',
  'auth.error.emailSignUpConflictGeneric':
    'Cannot register with this address. Try signing in or use another method.',
  'auth.error.googleUsePassword':
    'This email already has a password account. Sign in with email and password.',
  'auth.error.weakPassword': 'Password is too weak. Use at least 8 characters.',
  'auth.error.invalidEmail': 'Enter a valid email address.',
  'auth.error.invalidCredentials': 'Incorrect email or password.',
  'auth.error.tooManyRequests': 'Too many attempts. Please try again later.',
  'auth.error.network': 'Network error. Check your connection and try again.',
  'auth.error.unknown': 'Something went wrong. Please try again.',
  'auth.error.emptyEmail': 'Enter your email address.',
  'auth.error.emptyPassword': 'Enter your password.',
  'auth.emailVerification.message': 'Confirm your email address',
  'auth.emailVerification.resend': 'Resend email',
  'auth.emailVerification.dismiss': 'Close',
  'consent.analytics.message':
    'We use analytics cookies to understand how Todoes is used. You can accept or decline.',
  'consent.analytics.accept': 'Accept',
  'consent.analytics.reject': 'Decline',
  'auth.validation.passwordMismatch': 'Passwords do not match.',
  'logout.loading': 'Logging out...',
  'common.loading': 'Loading...',

  // =============================================
  // Task / Organize
  // =============================================
  'task.noDescription': 'No description',
  'task.date': 'Date:',
  'task.time': 'Time:',
  'task.showMore': 'Show More',
  'task.showLess': 'Show Less',

  // =============================================
  // Today Page
  // =============================================
  'todaypage.title': 'Today',
  'completionstreak.day': 'day in a row',
  'completionstreak.days': 'days in a row',

  // =============================================
  // Common (gedeeld tussen componenten)
  // =============================================
  'common.minutesShort': 'm',

  // =============================================
  // Planning (Horizon/Plan panels, PlanPage)
  // =============================================
  'plan.unscheduled': 'To schedule',
  'plan.partiallyScheduled': '{done} of {total} scheduled',
  'plan.overdue': 'Reschedule',
  'plan.nextAction': 'Next Actions',
  'plan.agenda': 'Calendar',
  'plan.agendaShow': 'Show calendar',
  'plan.agendaHide': 'Hide calendar',
  'plan.agendaLocked': 'Google Calendar sync (Lite feature)',
  'plan.planMode': 'Plan mode',
  'plan.planModeShow': 'Turn on Plan mode',
  'plan.planModeHide': 'Turn off Plan mode',
  'plan.weekRegion': 'Week overview',
  'plan.monthRegion': 'Month overview',
  'plan.planModeNeedsProject': 'Select exactly 1 project to plan',
  'plan.planModeRailTitle': 'Plan',
  'plan.calendarRegion': 'Day calendar',
  'plan.calendarKeyboardHint':
    'Use arrow keys to move between scheduled tasks in the calendar.',
  'planpage.accessDenied': 'Access denied. You are being logged out.',
  'planpage.noMetadata': 'tasks without metadata',
  'planpage.waitingOnSomeone': 'waiting on someone',

  // =============================================
  // GoBarModal
  // =============================================
  'gobar.noResults': 'No tasks found',
  'gobar.filterCommand': '→ Organize: show only {tags}',
  'gobar.createTask': 'Create task: "{query}"',
  'gobar.keyboardHint': '↑↓ navigate · Enter select · Esc close',

  // =============================================
  // LiveFocusTimer / TaskCheckbox / TaskExecutionActions / TaskMetadata
  // =============================================
  'livefocustimer.title': 'Live Focus Timer',
  'taskcheckbox.markComplete': 'Mark complete',
  'taskmetadata.fixOrder': 'Fix Order',
  'taskmetadata.dueDate': 'Due date',

  // =============================================
  // TaskForm
  // =============================================
  'taskform.deleteTask': 'delete task',
  'taskform.titleLabel': 'Title:',
  'taskform.titlePlaceholder': 'Task title',
  'taskform.backlog': 'Backlog',
  'taskform.backlogHint':
    'Not in active planning until you make the task active again.',
  'taskform.subtasks': 'Sub-tasks',
  'taskform.editTitle': 'Edit title',
  // Waarde EN label bewust Engels/ongewijzigd: 'Active'/'Backlog' zijn de letterlijke
  // task.status enum-waarden (datamodel) en tests/cascade-status.spec.js,
  // tests/bulk-edit.spec.js selecteren op exact deze tekst.
  'taskform.statusActive': 'Active',
  'taskform.statusBacklog': 'Backlog',
  'taskform.description': 'Description',
  'taskform.parentLabel': 'Parent task',
  'taskform.addTag': '+ add',
  'taskform.addProject': 'Add project',
  'taskform.addContext': 'Add context',
  'taskform.addPerson': 'Waiting for…',
  'taskform.changeParent': 'Change parent task',
  // Waarde bewust Engels: tests/task-edit.spec.js selecteert
  // getByRole('button', { name: /Cancel/i }) op deze exacte tekst.
  'taskform.cancel': 'Cancel',
  // Waarde bewust Engels: tests/task-edit.spec.js selecteert
  // getByRole('button', { name: /Save Changes/i }) resp. /Add Task/i op deze teksten.
  'taskform.saveChanges': 'Save Changes',
  'taskform.addTask': 'Add Task',

  // =============================================
  // TaskDescriptionEditor (Epic 6 Taak 0.4)
  // =============================================
  'taskdescriptioneditor.noDescription': 'No description — click to add',
  'taskdescriptioneditor.placeholder': 'No description',

  // =============================================
  // TaskInputInline
  // =============================================
  // Waarde bewust ongewijzigd: tests/dnd.spec.js, tests/cascade-*.spec.js,
  // tests/organize*.spec.js, tests/task-*.spec.js selecteren op
  // input[placeholder*="New subtask"].
  'taskinputinline.placeholder': 'New subtask (#proj @ctxt)...',

  // =============================================
  // TaskDateTimeFields
  // =============================================
  'taskdatetimefields.repeatEvery': 'Repeat every',
  'taskdatetimefields.period': 'Period',
  'taskdatetimefields.days': 'Days',
  'taskdatetimefields.weeks': 'Weeks',
  'taskdatetimefields.months': 'Months',
  'taskdatetimefields.date': 'Date',
  'taskdatetimefields.time': 'Time',
  'taskdatetimefields.duration': 'Duration',
  'taskdatetimefields.toggleRecurrence': 'toggle recurrence',

  // =============================================
  // TaskParentSelector
  // =============================================
  'taskparentselector.placeholder': 'Choose parent task',

  // =============================================
  // TaskTagFields
  // =============================================
  // Waarde bewust Engels: tests/cascade-project.spec.js selecteert
  // getByPlaceholder(/Add or select a project/i) op deze exacte tekst.
  'tasktagfields.projectPlaceholder': 'Add or select a project',
  'tasktagfields.contextsPlaceholder': 'Add or select contexts',
  'tasktagfields.personPlaceholder': 'Waiting for…',

  // =============================================
  // TaskItemBase / TaskItemSwipeable
  // =============================================
  'taskitembase.invalidTask': '[Invalid Task]',
  'taskitemswipeable.complete': 'Complete',
  'taskitemswipeable.snoozeToday': 'Today',
  'taskitemswipeable.snoozeTomorrow': 'Tomorrow',
  'taskitemmobilesortable.dragToReorder': 'Drag to reorder',

  // =============================================
  // TaskBulkEditModal
  // =============================================
  'taskbulkeditmodal.setDate': 'Set Date',
  'taskbulkeditmodal.duration': 'Duration',
  'taskbulkeditmodal.durationInvalid':
    'Invalid duration; try e.g. 30m, 1h, or 1u30',
  // Waarde bewust Engels: tests/bulk-edit.spec.js selecteert
  // modal.getByLabel(/Set Status/i) op deze exacte tekst.
  'taskbulkeditmodal.setStatus': 'Set Status',
  'taskbulkeditmodal.noChange': "Don't change",
  'taskbulkeditmodal.setProject': 'Set Project',
  'taskbulkeditmodal.clearProject': 'Clear project',
  'taskbulkeditmodal.setContext': 'Set Context',
  'taskbulkeditmodal.clearContext': 'Clear context',
  'taskbulkeditmodal.setPerson': 'Set waiting for',
  // Waarde bewust Engels: tests/bulk-edit.spec.js controleert
  // toContainText(/Bulk Edit/i).
  'taskbulkeditmodal.title': 'Edit {count} tasks',
  'taskbulkeditmodal.cancel': 'Cancel',
  // Waarde bewust Engels: tests/bulk-edit.spec.js selecteert
  // getByRole('button', { name: /Save Changes/i }).
  'taskbulkeditmodal.applyChanges': 'Save Changes',
  'taskbulkeditmodal.clearFieldShort': 'Clear',
  'taskbulkeditmodal.resetField': 'Reset',

  // =============================================
  // TaskGroup* (Next Actions/Overdue/Subtasks/Upcoming)
  // =============================================
  'taskgroupsubtasks.title': 'Sub-tasks',

  // =============================================
  // Today: acties-menus / content / triage / bulk actions
  // =============================================
  'bulkactionbar.selected': 'selected',
  'bulkactionbar.moveToToday': 'Move to Today',
  'bulkactionbar.completeAll': 'Complete All',
  'bulkactionbar.clearDates': 'Clear Dates',
  'bulkactionbar.cancel': 'Cancel',
  'todayviewcontent.overdue': 'Reschedule',
  'todayviewcontent.today': 'Today',
  'todayviewcontent.nextActions': 'Next Actions',
  'todayviewcontent.upcomingTasks': 'Planned',
  'todayviewcontent.upcomingEmpty': 'No planned tasks.',
  'todayviewcontent.completed': 'Completed',
  'todayviewcontent.appointments': 'Appointments',
  'todayviewcontent.appointmentUntitled': '(No title)',
  'todayviewcontent.deadlines': 'Deadlines',
  'todayviewcontent.todayInProgress': 'Your action for today is in progress!',
  'todayviewcontent.todayEmpty': 'No open tasks for today! 🎉',
  'todayviewcontent.todayNoTasksEver': 'Start with one task.',
  'todayviewcontent.addTaskToday': 'Add task for today',
  'todayviewcontent.todayNothingPlanned': 'Nothing planned for today.',
  'todayviewcontent.nextActionInProgress': 'Your next action is in progress!',
  'todayviewcontent.nextActionsEmpty': 'No next actions available.',
  // Waarden bewust ongewijzigd: tests/triage.spec.js selecteert
  // h3-elementen op deze exacte tekst ('Inbox'/'10 min'/'1 uur'/'4 uur').
  'triageboard.small': '10m',
  'triageboard.medium': '1h',
  'triageboard.large': '4h',

  // =============================================
  // English-locale sweep (Taak: English locale support)
  // =============================================
  'taskform.noSubtasks': 'No subtasks yet.',
  'taskinputquick.addError': 'An error occurred while adding the task.',
  'taskinputquick.addTask': 'Add task',
  'taskinputquick.createDetailedTask': 'Create detailed task',
  'taskdetailmetadata.rollupDuration': 'Calculated duration (sum of subtasks)',
  'taskdetailmetadata.estimatedDuration': 'Estimated duration',
  'taskexecutionactions.subtaskProgress': 'subtasks completed',
  'taskform.rootParent': 'Top level',
  'taskform.rootParentHint': 'This task has no parent task.',
  'useTaskActions.followUpError': 'Error scheduling follow-up',
  'taskmetrics.noProject': 'No project',
  'filterbar.all': 'All',
  'filterbar.toolbar': 'Task filters',
  'appbar.devTierSwitch': 'Dev: tier →',
  'appbar.logoAlt': 'Riposo',
  'appbar.filter': 'Filter',
  'appbar.inbox': 'Inbox',
  'appbar.logout': 'Log out',
  'appbar.feedback': 'Feedback',
  'appbar.accountMenu': 'Account menu',
  'appbar.navMenu': 'Navigation menu',
  'help.menuItem': 'Help',
  'settings.menuItem': 'Settings',
  'settings.title': 'Settings',
  'settings.close': 'Close settings',
  'settings.account.title': 'Account',
  'settings.account.displayName.label': 'Your name',
  'settings.account.displayName.save': 'Save name',
  'settings.account.displayName.errorEmpty': 'Enter a name to save.',
  'settings.account.displayName.errorTooLong': 'Use at most 50 characters.',
  'settings.account.displayName.errorSave': 'Could not save your name. Try again.',
  'settings.account.signInMethod.title': 'Sign-in method',
  'settings.account.signInMethod.google': 'Google',
  'settings.account.signInMethod.password': 'Email and password',
  'settings.account.signInMethod.unknown': 'Unknown',
  'settings.account.signInMethod.emailVerified': 'Verified',
  'settings.account.signInMethod.emailUnverified': 'Not verified yet',
  'settings.account.marketing.label': 'News and updates about Riposo',
  'settings.account.marketing.description':
    'Occasional product news. You can turn this off anytime.',
  'settings.account.marketing.errorSave':
    'Could not update marketing preferences. Try again.',
  'settings.account.delete.button': 'Delete account',
  'settings.account.delete.reauthTitle': 'Confirm your password',
  'settings.account.delete.reauthBody':
    'Enter your password again before you can delete your account.',
  'settings.account.delete.reauthPasswordLabel': 'Password',
  'settings.account.delete.reauthContinue': 'Continue',
  'settings.account.delete.confirmTitle': 'Delete your account permanently?',
  'settings.account.delete.confirmBody':
    'This removes your tasks and account data. Type your email address to confirm.',
  'settings.account.delete.confirmEmailLabel': 'Your email address',
  'settings.account.delete.confirmAction': 'Delete my account',
  'settings.account.delete.errorEmailMismatch':
    'The email address does not match your account.',
  'settings.account.delete.errorData':
    'Could not delete your data. Check your connection and try again.',
  'settings.account.delete.errorAuthUserRemains':
    'Your data was removed but signing out of your login failed. Sign in again and repeat account deletion.',
  'login.accountDeleted':
    'Your account has been deleted. You can create a new account if you sign in again.',
  'settings.language.title': 'Language',
  'settings.language.ariaLabel': 'App language',
  'settings.language.option.nl': 'Nederlands',
  'settings.language.option.en': 'English',
  'help.title': 'Help',
  'help.close': 'Close',
  'help.shortcuts.title': 'Keyboard shortcuts',
  'help.shortcuts.intro': 'Work faster without the mouse.',
  'help.shortcuts.more': 'More shortcuts',
  'help.shortcuts.group.global': 'Global',
  'help.shortcuts.group.list': 'Task list (list focused, not typing)',
  'help.shortcuts.group.input': 'Input field',
  'help.shortcuts.group.other': 'Other',
  'help.shortcuts.footnote.structuralNav':
    'Indent and outdent do not work in flat lists (e.g. Plan panels, Inbox, waiting list). Tab is not bound; use Ctrl+] and Ctrl+[.',
  'help.shortcuts.quickAdd': 'Focus quick add',
  'help.shortcuts.goBar': 'Search and commands (GoBar)',
  'help.shortcuts.pageNav': 'Go to Today, Plan, Organize, or Dashboard',
  'help.shortcuts.listSelect': 'Select a task',
  'help.shortcuts.listEdit': 'Rename task (inline)',
  'help.shortcuts.listComplete': 'Complete or reopen task',
  'help.shortcuts.listReorder': 'Move task in the list',
  'help.shortcuts.listAddAbove': 'New task above selection',
  'help.shortcuts.listAddBelow': 'New task below selection',
  'help.shortcuts.listAddSubtask': 'Add subtask',
  'help.shortcuts.listIndent':
    'Indent task (subtask of previous); not in flat lists',
  'help.shortcuts.listOutdent': 'Outdent task; not in flat lists',
  'help.shortcuts.listFollowUp': 'Schedule follow-up',
  'help.shortcuts.listFocus': 'Start or stop focus',
  'help.shortcuts.listOpen': 'Open task (detail)',
  'help.shortcuts.listDelete': 'Delete task (with confirmation)',
  'help.shortcuts.listClearSelection': 'Clear selection',
  'help.shortcuts.inputSubmit': 'Add task or confirm edit',
  'help.shortcuts.inputCancel': 'Cancel or clear field',
  'help.shortcuts.goBarNav': 'Choose a result or close GoBar',
  'help.shortcuts.calendarTaskNav': 'Move between scheduled tasks on the calendar',
  'help.shortcuts.organizeBulkEdit': 'Open bulk edit when multiple tasks are selected',
  'help.shortcuts.mouseMultiSelect': 'Select or deselect tasks in a list',
  'help.shortcuts.dashboardBarNav': 'Dashboard charts: choose an item',
  'help.shortcuts.filterBarNav': 'Filter bar: choose a filter',
  'help.shortcuts.keys.quickAdd': 'n',
  'help.shortcuts.keys.goBar': 'Ctrl+K',
  'help.shortcuts.keys.goBarMac': '⌘K',
  'help.shortcuts.keys.pageNav': 'Alt+1 … Alt+4',
  'help.shortcuts.keys.listSelect': '↑ ↓',
  'help.shortcuts.keys.listEdit': 'F2',
  'help.shortcuts.keys.listComplete': 'Space',
  'help.shortcuts.keys.listReorder': 'Ctrl+↑ Ctrl+↓',
  'help.shortcuts.keys.listAddAbove': 'a',
  'help.shortcuts.keys.listAddBelow': 'b',
  'help.shortcuts.keys.listAddSubtask': 's',
  'help.shortcuts.keys.listIndent': 'Ctrl+]',
  'help.shortcuts.keys.listOutdent': 'Ctrl+[',
  'help.shortcuts.keys.listFollowUp': 'Ctrl+Space',
  'help.shortcuts.keys.listFocus': 'Ctrl+Enter',
  'help.shortcuts.keys.listOpen': 'Enter',
  'help.shortcuts.keys.listDelete': 'Delete',
  'help.shortcuts.keys.listClearSelection': 'Esc',
  'help.shortcuts.keys.inputSubmit': 'Enter',
  'help.shortcuts.keys.inputCancel': 'Esc',
  'help.shortcuts.keys.goBarNav': '↑ ↓ Enter Esc',
  'help.shortcuts.keys.calendarTaskNav': '← → ↑ ↓',
  'help.shortcuts.keys.organizeBulkEdit': 'Enter',
  'help.shortcuts.keys.mouseMultiSelect': 'Ctrl+click, Shift+click',
  'help.shortcuts.keys.dashboardBarNav': '← → Enter Space',
  'help.shortcuts.keys.filterBarNav': '← → Home End Enter Space',
  'help.shortcuts.col.key': 'Key',
  'help.shortcuts.col.action': 'Action',
  'help.quickbar.title': 'Quick entry',
  'help.quickbar.intro':
    'Type these characters in a new task to place it right away.',
  'help.quickbar.col.token': 'Symbol',
  'help.quickbar.col.meaning': 'Meaning',
  'help.quickbar.col.example': 'Example',
  'help.quickbar.row.project.meaning': 'Project: where the task belongs.',
  'help.quickbar.row.project.example': '#work',
  'help.quickbar.row.context.meaning': 'Context: when or where you do it.',
  'help.quickbar.row.context.example': '@office',
  'help.quickbar.row.duration.meaning':
    'Duration: how long you think it will take. With ~, m means minutes; with *, m means month.',
  'help.quickbar.row.duration.example': '~30m, ~1h, ~1h30',
  'help.quickbar.row.person.meaning': 'Person (one per task).',
  'help.quickbar.row.person.example': '+jan',
  'help.quickbar.row.date.meaning': 'Planned date.',
  'help.quickbar.row.date.example': '>tomorrow, >friday, >today',
  'help.quickbar.row.recurrence.meaning':
    'Recurrence: number + d/w/m/y, or words like *weekly or *monthly.',
  'help.quickbar.row.recurrence.example': '*1m, *2w, *1d, *1y, *weekly',
  'help.quickbar.example': 'Review quote #work @office ~30m >friday',
  'help.restartIntro.title': 'Restart intro',
  'help.restartIntro.body':
    'You will walk through the intro again and create a new task as part of it.',
  'help.restartIntro.confirm': 'Restart',
  'help.restartIntro.cancel': 'Cancel',
  'onboarding.organizeIntro.title':
    'This is where you flesh out tasks and add structure.',
  'onboarding.organizeIntro.body':
    'Drag tasks to change their order (or use Ctrl+↑↓). Select a task to add subtasks and fill in details on the right.',
  'onboarding.backlogIntro.title':
    'Tasks in Backlog stay out of sight until you have time for them again.',
  'onboarding.backlogIntro.body':
    'You move a task there from the task details.',
  'onboarding.inboxIntro.title':
    'Here you fill in details for tasks that are not complete yet.',
  'onboarding.inboxIntro.body':
    'Drag a task to a duration, project, or context. Without a duration, a task counts as 15 minutes.',
  'onboarding.contextIntro.title':
    'Context is where or when you do something, for example @home or @on-the-go.',
  'onboarding.contextIntro.body':
    'Create a context here or type `@context` on a task. Then you can drag tasks here.',
  'a11y.skipToContent': 'Skip to main content',

  // =============================================
  // Onboarding tour (/welcome)
  // =============================================
  'onboarding.tour.title': 'From loose thought to plan, in a minute.',
  'onboarding.tour.skip': 'Skip intro',
  'onboarding.tour.progress': 'Step {current} of {total}',
  'onboarding.displayNameStep.title': 'What should I call you?',
  'onboarding.displayNameStep.body':
    'A first name is enough — it helps me address you personally.',
  'onboarding.displayNameStep.label': 'Your name',
  'onboarding.displayNameStep.submit': 'Continue',
  'onboarding.displayNameStep.errorEmpty': 'Enter your name to continue.',
  'onboarding.displayNameStep.errorTooLong': 'Use at most 50 characters.',
  'onboarding.displayNameStep.errorSave':
    'Could not save. Please try again.',
  'onboarding.displayNameStep.marketingOptIn':
    'Keep me updated on news and updates about Riposo.',
  'onboarding.taskStep.title': "What's keeping you busy?",
  'onboarding.taskStep.body': 'Write one down. The rest comes next.',
  'onboarding.taskStep.placeholder': 'For example: finish the quote',
  'onboarding.projectStep.title': 'What does this belong to?',
  'onboarding.projectStep.body':
    "A project groups tasks that belong together, like a client or a move. You'll spot them by the #: type one, like #work.",
  'onboarding.projectStep.placeholder': '#work',
  'onboarding.projectStep.submit': 'Next',
  'onboarding.subtaskStep.title': 'What is the first step?',
  'onboarding.subtaskStep.body':
    'Start with the first step — it makes getting started easier.',
  'onboarding.subtaskStep.plusHint': 'Press + to add a subtask.',
  'onboarding.subtaskStep.placeholder': 'For example: look up the numbers',
  'onboarding.subtaskStep.enterHint': 'Press Enter to add',
  'onboarding.subtaskStep.skip': 'Skip',
  'onboarding.subtaskStep.done': 'Done',
  'onboarding.more.title': 'More on your list?',
  'onboarding.more.body': 'Add whatever you want, as much as you want.',
  'onboarding.more.skip': 'Skip',
  'onboarding.more.done': 'Done',
  'onboarding.more.contextPrompt':
    'When or where will you do this? Add @home or @onTheGo.',
  'onboarding.more.durationPrompt':
    'How long will this take? Add `~30m` or `~1h`.',
  'onboarding.more.durationDefault':
    'Leave it empty and 15 minutes applies.',
  'onboarding.more.laterHint': 'You can always fill this in later.',
  'onboarding.slot.dragHintFirstStep':
    'This is your Next Action, the first step of your task. Drag it to a moment in your planning.',
  'onboarding.slot.dragHintTask':
    'Drag your task to a moment in your planning.',
  'onboarding.slot.skip': 'Skip',
  'onboarding.slot.skipLaterHint': 'You can schedule it later.',
  'onboarding.duration.body':
    'By default a task lasts 15 minutes. Drag the bottom edge to change that.',
  'onboarding.duration.next': 'Next',
  'onboarding.outro.planned':
    'Nice, your first step is in your planning.',
  'onboarding.outro.plannedWithMore':
    'Nice, your first step is in your planning. The other tasks are ready in To schedule: drag them in and fill your day.',
  'onboarding.outro.unplanned':
    'Everything is ready in To schedule: drag a task to a moment and fill your day.',
  'onboarding.outro.start': 'Get started',
  'onboarding.outro.close': 'Close',
  'onboarding.outro.helpHint':
    'Shortcuts and help: click your initials at the top right → Help.',

  // =============================================
  // PrivacyPage (temporary /privacy route)
  // =============================================
  'privacy.langToggle.nl': 'Nederlands',
  'privacy.langToggle.en': 'English',
  'privacy.langToggle.groupLabel': 'Language',
  'privacy.eyebrow': 'Draft — not yet final',
  'privacy.title': 'Todoes Privacy Policy',
  'privacy.updated': 'Last updated: {date} · version 0.2',
  'privacy.intro':
    'This overview describes what data Todoes collects, why, and what your rights are. It is based on how the app actually works today.',
  'privacy.placeholderNotice':
    'Company details (name, registration number, address, contact email) are still missing — the placeholders below need to be filled in before publishing.',

  'privacy.section1.heading': '1. Who is responsible for your data',
  'privacy.section1.body':
    '[Company name], based in [city], registration number [registration number], is responsible for processing personal data via Todoes. Questions? Email [contact email].',

  'privacy.section2.heading': '2. What data we process, and why',
  'privacy.section2.accountHeading': 'Account and sign-in',
  'privacy.section2.accountLi1':
    'Email address and hashed password (when registering with email) — to create and manage your account.',
  'privacy.section2.accountLi2':
    'Name, email address and profile photo from your Google account (when signing in with Google) — to create and manage your account.',
  'privacy.section2.accountLi3':
    'A temporary user ID when using guest mode (anonymous sign-in).',
  'privacy.section2.accountLi4':
    'Number of logins and last login time — for account management.',
  'privacy.section2.tasksHeading': 'Tasks and planning',
  'privacy.section2.tasksBody':
    'Task titles, hierarchy, deadlines and status that you enter yourself are stored so the app can work. Completed tasks left unchanged for 6 days are automatically archived (not deleted).',
  'privacy.section2.gcalHeading': 'Google Calendar connection (optional)',
  'privacy.section2.gcalBody':
    'If you connect your Google Calendar, we fetch calendar items with your consent (title, time, location, description, and any attendee email addresses) and cache them to show alongside your tasks. This only happens after you explicitly connect it and can be disconnected at any time.',
  'privacy.section2.analyticsHeading': 'Usage analytics (Firebase Analytics / GA4)',
  'privacy.section2.analyticsBody':
    'We measure a limited set of events (signup/login with method, task created/completed, clicks on upgrade prompts) — only after you give consent via the cookie banner. If you decline, nothing is measured.',
  'privacy.section2.sentryHeading': 'Error tracking (Sentry)',
  'privacy.section2.sentryBody':
    'When a technical error occurs, we automatically log error details (message, stack trace) linked to your user ID and email address, to detect and fix issues. This data is processed within the EU.',

  'privacy.section3.heading': '3. Who we share data with',
  'privacy.section3.body':
    'We never sell your data. We use the following processors: Google Firebase/Cloud (sign-in, database, background jobs, analytics), the Google Calendar API (only when connected), and Sentry (error tracking, EU). A data processing agreement is in place with each processor.',

  'privacy.section4.heading': '4. Transfers outside the EEA',
  'privacy.section4.body':
    'Where Google processes data outside the EEA, this happens under the EU-US Data Privacy Framework and/or standard contractual clauses. Sentry processes data within the EU.',

  'privacy.section5.heading': '5. How long we keep data',
  'privacy.section5.li1':
    'Account and task data: for as long as your account exists. Completed tasks are archived after 6 days, not deleted.',
  'privacy.section5.li2':
    'You can delete your own account and all associated data (tasks, preferences, calendar cache) via Settings → Account. Once confirmed, this happens immediately and cannot be undone.',
  'privacy.section5.li3':
    'Error logs (Sentry) and analytics data (GA4) are kept according to those services’ default retention periods.',

  'privacy.section6.heading': '6. Your rights',
  'privacy.section6.body':
    'You have the right to access, correct, delete and restrict your data, the right to object, and the right to data portability. Contact us at [contact email]. If you disagree with how we process your data, you can file a complaint with the Dutch Data Protection Authority (Autoriteit Persoonsgegevens).',

  'privacy.section7.heading': '7. Cookies',
  'privacy.section7.body':
    'We only use analytics cookies (Google Analytics 4), and only after you consent via the banner shown on your first visit. Your language preference is stored locally in your browser and is not a cookie.',

  'privacy.section8.heading': '8. Changes',
  'privacy.section8.body':
    'We may update this policy as the app changes. The date at the top shows when it was last changed.',
};

export default en;
